import * as React from 'react';
import { connect } from 'react-redux';
import KPInputTextArea from '../../SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import './KPInputTextAreaPage.css';
import '../../StylingProjectMain.css';

class KPInputTextAreaPage extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            inputTest_type: "input",
            inputTest_required: false,
            inputTest_disabled: false,
            inputTest_notice: false,
            inputTest_noticeType: false,
            inputTest_successTick: false,
            inputTest_noticeMessage: <>Notice / message here <br /> Notice / message here </>,
            inputTest_presetValue: "",
            inputTest_demoType: "controlonly"
        };
        this.inputTest = this.inputTest.bind(this);
    }

    async inputTest(whichAction) {
        switch (whichAction) {
             case 'error':
                await this.setState({ inputTest_notice: true, inputTest_noticeType: "error", inputTest_noticeMessage: <>Error message <br /> Error message</> });
                break;
            case 'warning':
                await this.setState({ inputTest_notice: true, inputTest_noticeType: "warning", inputTest_noticeMessage: <>Warning message <br/> Warning message</> });
                break;
            case 'notice':
                await this.setState({ inputTest_notice: true, inputTest_noticeType: "notice", inputTest_noticeMessage: <>Notice message <br /> Notice message</> });
                break;
            case 'success':
                await this.setState({ inputTest_notice: true, inputTest_noticeType: "success", inputTest_noticeMessage: <>Success message <br /> Success message</> });
                break;
            case 'clearmessage':
                await this.setState({ inputTest_notice: false, inputTest_noticeType: false, inputTest_noticeMessage: false });
                break;
            case 'email':
                await this.setState({ inputTest_type: "email"});
                break;
            case 'text':
                await this.setState({ inputTest_type: "text" });
                break;
            case 'number':
                await this.setState({ inputTest_type: "number" });
                break;
            case 'password':
                await this.setState({ inputTest_type: "password" });
                break;
            case 'type-input':
                await this.setState({ inputTest_type: "input" });
                break;
            case 'type-textarea':
                await this.setState({ inputTest_type: "textarea" });
                break;
            case 'disabled':
                await this.setState({ inputTest_disabled: true });
                break;
            case 'enabled':
                await this.setState({ inputTest_disabled: false });
                break;
            case 'required':
                await this.setState({ inputTest_required: true});
                break;
            case 'presetvalue':
                await this.setState({ inputTest_presetValue: "existing value here" });
                break;
            case 'successtick':
                await this.setState({ inputTest_successTick: true});
                break;
            case 'demotype-controlonly':
                await this.setState({ inputTest_demoType: "controlonly"});
                break;
            case 'demotype-formshow':
                await this.setState({ inputTest_demoType: "formshow" });
                break;
            default:
                await this.setState({
                    inputTest_type: "input",
                    inputTest_required: false,
                    inputTest_disabled: false,
                    inputTest_notice: false,
                    inputTest_noticeType: false,
                    inputTest_successTick: false,
                    inputTest_noticeMessage: <>Notice / message here <br /> Notice / message here </>,
                    inputTest_presetValue: "",
                    inputTest_demoType: "controlonly"
                });
            break;
        }
    }
   
    public render() {
        return (
            <div id="appContainer" className="noProfile styling-project styling-project-inputtextarea-page">
                <span className="styling-foundation-page-header">
                    SSP KP Input / Text Area Component
                </span>
                <br />
                <div className="styling-foundation-input-container-large">
                    <div className="row noma">
                        <div className="col-12 nopa">
                            {/*/// Demo: Control Only ///*/}
                            {this.state.inputTest_demoType === "controlonly" &&
                                <>
                                    <KPInputTextArea
                                        id="test1"
                                        name="test1"
                                        type={this.state.inputTest_type}
                                        className="myinputclass"
                                        value="" 
                                        label={"Placeholder"}
                                        labelAfterSelection={"Label"}
                                        showLabelAfterSelection={true}
                                        notice={this.state.inputTest_notice}
                                        noticeType={this.state.inputTest_noticeType}
                                        noticeMessage={this.state.inputTest_noticeMessage}
                                        successTick={this.state.inputTest_successTick}
                                        required={this.state.inputTest_required}
                                        readOnly={false}
                                        autoFocus={false}
                                        minLength={10}
                                        maxLength={false}
                                        disabled={this.state.inputTest_disabled}
                                        form="mainform"
                                    />
                                </>
                            }
                            
                            {/*
                               Usage:
                               
                               <KPInputTextArea
                                id="test2"
                                name="test2"
                                type={this.state.inputTest_type}
                                className="myinputclass"
                                label={"Placeholder"}
                                labelAfterSelection={"Label"}
                                showLabelAfterSelection={true}
                                value={this.state.inputTest_presetValue}
                                notice={this.state.inputTest_notice}
                                noticeType={this.state.inputTest_noticeType}
                                noticeMessage={this.state.inputTest_noticeMessage}
                                successTick={this.state.inputTest_successTick}
                                required={this.state.inputTest_required}
                                readOnly={false}
                                autoFocus={false}
                                minLength={10}
                                maxLength={20}
                                disabled={this.state.inputTest_disabled}
                                form="mainform"
                            />*/}


                            {/*/// Demo: Form Pretend ///*/}
                            {this.state.inputTest_demoType === "formshow" &&
                                <>
                                    <div className="styling-foundation-input-formshow">
                                        <KPInputTextArea
                                            id="test2"
                                            name="test2"
                                            type="input"
                                            className="mb-15px"
                                            label={"Full name and surname"}
                                            labelAfterSelection={"Please enter your full name and surname"}
                                            showLabelAfterSelection={true}
                                            value="Keanu Reeves"
                                            notice={this.state.inputTest_notice}
                                            noticeType={this.state.inputTest_noticeType}
                                            noticeMessage={this.state.inputTest_noticeMessage}
                                            successTick={this.state.inputTest_successTick}
                                            required={this.state.inputTest_required}
                                            readOnly={false}
                                            autoFocus={false}
                                            minLength={10}
                                            maxLength={false}
                                            disabled={this.state.inputTest_disabled}
                                            form="mainform"
                                        />

                                        <KPInputTextArea
                                            id="test3"
                                            name="test3"
                                            type="email"
                                            className="mb-15px"
                                            label={"Email address"}
                                            showLabelAfterSelection={true}
                                            value="neo@thematrix.com"
                                            notice={this.state.inputTest_notice}
                                            noticeType={this.state.inputTest_noticeType}
                                            noticeMessage={this.state.inputTest_noticeMessage}
                                            successTick={this.state.inputTest_successTick}
                                            required={this.state.inputTest_required}
                                            readOnly={false}
                                            autoFocus={false}
                                            minLength={10}
                                            maxLength={false}
                                            disabled={this.state.inputTest_disabled}
                                            form="mainform"
                                        />

                                        <KPInputTextArea
                                            id="test4"
                                            name="test4"
                                            type="password"
                                            className="mb-15px"
                                            label={"Please enter your password"}
                                            showLabelAfterSelection={true}
                                            value="thereisnospoon123"
                                            notice={this.state.inputTest_notice}
                                            noticeType={this.state.inputTest_noticeType}
                                            noticeMessage={this.state.inputTest_noticeMessage}
                                            successTick={this.state.inputTest_successTick}
                                            required={this.state.inputTest_required}
                                            readOnly={false}
                                            autoFocus={false}
                                            minLength={10}
                                            maxLength={false}
                                            disabled={this.state.inputTest_disabled}
                                            form="mainform"
                                        />

                                        <KPInputTextArea
                                            id="test5"
                                            name="test5"
                                            type="password"
                                            className="mb-15px"
                                            label={"Re-type password"}
                                            showLabelAfterSelection={true}
                                            value=""
                                            notice="error"
                                            noticeType="error"
                                            noticeMessage={this.state.inputTest_noticeMessage}
                                            successTick={this.state.inputTest_successTick}
                                            required={this.state.inputTest_required}
                                            readOnly={false}
                                            autoFocus={false}
                                            minLength={10}
                                            maxLength={false}
                                            disabled={this.state.inputTest_disabled}
                                            form="mainform"
                                        />

                                        <KPInputTextArea
                                            id="test6"
                                            name="test6"
                                            type="textarea"
                                            className="mb-15px"
                                            label={"Please tell us why you want to join us"}
                                            showLabelAfterSelection={true}
                                            value=""
                                            notice={this.state.inputTest_notice}
                                            noticeType={this.state.inputTest_noticeType}
                                            noticeMessage={this.state.inputTest_noticeMessage}
                                            successTick={this.state.inputTest_successTick}
                                            required={this.state.inputTest_required}
                                            readOnly={false}
                                            autoFocus={false}
                                            minLength={10}
                                            maxLength={false}
                                            disabled={this.state.inputTest_disabled}
                                            form="mainform"
                                        />
                                    </div>
                                    <div className="ssp-styling-extrabottom-space"></div>
                                </>
                            }

                        </div>
                        <div className="stylingproject-fieldsetcontainer">
                            <fieldset className="styling-foundation-basic ">
                                <legend>
                                    {this.state.inputTest_demoType === "formshow" &&
                                        <>
                                            <b>Example form</b> | &nbsp;
                                        </>
                                    }
                                    {this.state.inputTest_demoType === "controlonly" &&
                                        <>
                                            <b>Control only</b> | &nbsp;
                                        </>
                                    }
                                    {this.state.inputTest_type !== "textarea" &&
                                        <>
                                            SSP <b>Input Field </b> Test Options
                                        </>
                                    }
                                    {this.state.inputTest_type === "textarea" &&
                                        <>
                                            SSP <b>TextArea </b> Test Options
                                        </>
                                    }
                                </legend>
                                 {this.state.inputTest_demoType === "formshow" &&
                                    <>
                                        <input type="button" className="ssp-styling-demo-type-button" value="Change Demo Type: Control Only" onClick={() => this.inputTest('demotype-controlonly')} />
                                        <br />
                                    </>
                                }
                                {this.state.inputTest_demoType === "controlonly" &&
                                    <>
                                        <input type="button" className="ssp-styling-demo-type-button" value="Change Demo Type: Form Example" onClick={() => this.inputTest('demotype-formshow')} />
                                        <br />
                                        {this.state.inputTest_type === "textarea" &&
                                            <>
                                            <input type="button" className="ssp-styling-demo-type-button-emphasis" value="Change Type: Input" onClick={() => this.inputTest('type-input')} />
                                            </>
                                        }
                                        {(this.state.inputTest_type && this.state.inputTest_type !== "textarea") &&
                                            <>
                                            <input type="button" className="ssp-styling-demo-type-button-emphasis" value="Change Type: TextArea" onClick={() => this.inputTest('type-textarea')} />
                                            </>
                                        }
                                    </>
                                }
                                {this.state.inputTest_type !== "textarea" &&
                                    <> 
                                        <input type="button" value="Error" onClick={() => this.inputTest('error')} />
                                        <input type="button" value="Warning" onClick={() => this.inputTest('warning')} />
                                        <input type="button" value="Notice" onClick={() => this.inputTest('notice')} />
                                        <input type="button" value="Success" onClick={() => this.inputTest('success')} />
                                        <input type="button" value="Clear message" onClick={() => this.inputTest('clearmessage')} />
                                        <input type="button" value="Success Tick" onClick={() => this.inputTest('successtick')} />
                                        <br />
                                        <input type="button" value="Type: Password Mode" onClick={() => this.inputTest('password')} />
                                        <input type="button" value="Type: Email" onClick={() => this.inputTest('email')} />
                                        <input type="button" value="Type: Text Input" onClick={() => this.inputTest('text')} />
                                        <input type="button" value="Type: Number" onClick={() => this.inputTest('number')} />
                                        <br />
                                        <input type="button" value="Disabled" onClick={() => this.inputTest('disabled')} />
                                        <input type="button" value="Enabled" onClick={() => this.inputTest('enabled')} />
                                        <input type="button" value="Required" onClick={() => this.inputTest('required')} />
                                        <input type="button" value="Reset" onClick={() => this.inputTest('default')} />
                                    </>
                                }
                                {this.state.inputTest_type === "textarea" &&
                                    <>
                                        <input type="button" value="Error" onClick={() => this.inputTest('error')} />
                                        <input type="button" value="Warning" onClick={() => this.inputTest('warning')} />
                                        <input type="button" value="Notice" onClick={() => this.inputTest('notice')} />
                                        <input type="button" value="Success" onClick={() => this.inputTest('success')} />
                                        <input type="button" value="Clear message" onClick={() => this.inputTest('clearmessage')} />
                                        <br />
                                        <input type="button" value="Disabled" onClick={() => this.inputTest('disabled')} />
                                        <input type="button" value="Enabled" onClick={() => this.inputTest('enabled')} />
                                        <input type="button" value="Required" onClick={() => this.inputTest('required')} />
                                        <input type="button" value="Reset" onClick={() => this.inputTest('default')} />
                                    </>
                                }
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KPInputTextAreaPage)